import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { technologiesBadgeColor } from '../utils/values';

const variants = {
	hidden: {
		opacity: 0,
		scale: 0.95,
	},
	visible: {
		opacity: 1,
		scale: 1,
		transition: {
			duration: 0.1,
		},
	},
};

export const ProjectCard = ({ project, setModal }) => {
	const { ref, inView } = useInView({
		threshold: 0.2,
		triggerOnce: true,
	});

	useEffect(() => {
		console.log(inView, project.title);
	}, [inView]);

	return (
		<motion.div ref={ref} variants={variants} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="card">
			<img src={`/projects/${project.image}`} className="card-image" alt="project" onClick={() => setModal({ image: `/projects/${project.image}`, imageAlt: project.title, show: true })} />
			<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 8, flex: 1 }}>
				<div className="card-text">
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<h2 style={{ marginBlock: 5 }}>{project.title}</h2>
						<span style={{ fontSize: 14, color: '#777', paddingInline: 10 }}>{project.date}</span>
					</div>
					<p style={{ marginBlock: 5 }}>{project.description}</p>
				</div>

				<div className="badges-and-buttons-container">
					<div className="card-badge">
						{project.technologies?.map((technology, index) => (
							<span key={index} style={{ backgroundColor: technologiesBadgeColor[technology].backgroundColor, color: technologiesBadgeColor[technology].color }} className="badge">
								{technology}
							</span>
						))}
					</div>

					{/* buttons for demo and repo */}
					{(!!project.demo || !!project.code || !!project.npm) && (
						<div className="card-buttons">
							{!!project.demo && (
								<a className="btn demo" href={project.demo} target="_blank" rel="noopener noreferrer">
									Demo
								</a>
							)}
							{!!project.code && (
								<a className="btn code" href={project.code} target="_blank" rel="noopener noreferrer">
									Code
								</a>
							)}
							{!!project.npm && (
								<a className="btn npm" href={project.npm} target="_blank" rel="noopener noreferrer">
									NPM
								</a>
							)}
						</div>
					)}
				</div>
			</div>
		</motion.div>
	);
};
